import React from 'react'

import { Heading } from '../'

export const ReportHeader = ({ heading, subheading1, subheading2, date, valuesAtDate}) => (
  <div className='page-header-branded'>
    <div className='padded-container'>
      <div className='slds-grid slds-wrap'>
        <div className='slds-col slds-size_6-of-12'>
          <Heading size='large' className='u-text-caps'>
            {heading}
          </Heading>
          {date &&
            <div className='report-date u-text-caps'>
              {date}
            </div>
          }
          <div className='slds-col slds-size_6-of-12 slds-m-top_medium'>
            {subheading1
              ? <div>
                  {subheading1}
                  <br />
                </div>
              : <span></span>
            }
            {subheading2 &&
              <div>
                {subheading2}
                <br />
              </div>
            }
            Values as at {valuesAtDate}
          </div>
        </div>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/report-header/index.js